<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">{{ title }}</legend>
    <div class="search-filter__dates">
      <label class="search-filter__date">
        <span :class="`search-filter__date-name`">
          Измененные
          <br>
          с &nbsp;&nbsp;
          <input type="date" id = "modifiedFrom" :value = "modifiedFromValue" @change="handleChange(0)">
          <br>
          по
          <input type="date" id = "modifiedTo" :value = "modifiedToValue" @change="handleChange(1)">
        </span>
      </label>

      <label class="search-filter__date">
        <span :class="`search-filter__date-name`">
          Введенные
          <br>
          с &nbsp;&nbsp;
          <input type="date" id = "enteredFrom" :value = "enteredFromValue" @change="handleChange(2)">
          <br>
          по
          <input type="date" id = "enteredTo" :value = "enteredToValue" @change="handleChange(3)">
        </span>
      </label>

      <label class="search-filter__date">
        <span :class="`search-filter__date-name`">
          Отмененные
          <br>
          с &nbsp;&nbsp;
          <input type="date" id = "canceledFrom" :value = "canceledFromValue" @change="handleChange(4)">
          <br>
          по
          <input type="date" id = "canceledTo" :value = "canceledToValue" @change="handleChange(5)">
        </span>
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    modifiedFromValue: {
      type: String,
      default: () => ''
    },
    modifiedToValue: {
      type: String,
      default: () => ''
    },
    enteredFromValue: {
      type: String,
      default: () => ''
    },
    enteredToValue: {
      type: String,
      default: () => ''
    },
    canceledFromValue: {
      type: String,
      default: () => ''
    },
    canceledToValue: {
      type: String,
      default: () => ''
    }
  },

  methods: {
    handleChange(id) {
      let name;
      let value;
      if (id === 0) {
        name = "Измененные с";
        value = modifiedFrom.value;
      }
      else if (id === 1) {
        name = "Измененные по";
        value = modifiedTo.value;
      }
      else if (id === 2) {
        name = "Введенные с";
        value = enteredFrom.value;
      }
      else if (id === 3) {
        name = "Введенные по";
        value = enteredTo.value;
      }
      else if (id === 4) {
        name = "Отмененные с";
        value = canceledFrom.value;
      }
      else if (id === 5) {
        name = "Отмененные по";
        value = canceledTo.value;
      }
      this.$emit('dates-changed', {
        id: id,
        name: name,
        value: value
      })
    }
  }
}
</script>
